export enum LogoTypeEnum {
  DARK = 'dark',
  LIGHT = 'light'
}

export interface LogoInterface {
  type: LogoTypeEnum.DARK | LogoTypeEnum.LIGHT
  rauter?: any
}
